import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
  getTaskHistory: async ({ id, page }) =>
    apiCall(`${config.baseAPIUrl}/history/list/${id}?page=${page}&limit=20`, {
      method: 'POST',
    }),
}
